import styled from "styled-components";

const StyledMobileMenuButtonBundle = styled.button`
  @media (max-width: 859px) {
    padding: 10px;
    width: 28px;
    height: 28px;
    box-sizing: content-box;
    fill: ${({theme}) => theme.colors.black};

    svg {
      width: 28px;
      height: 28px;
      fill: ${({theme}) => theme.colors.brand};
    }

    &:hover,
    &:focus {
      fill: ${({theme}) => theme.colors.brand};
    }
  }
  @media (min-width: 860px) {
    display: none;
  }

`;
export default StyledMobileMenuButtonBundle;